export function unitVector(vector: {
  x: number;
  y: number;
}): { x: number; y: number } | null {
  const length = Math.hypot(vector.x, vector.y);
  if (length === 0) {
    return null;
  }
  return { x: vector.x / length, y: vector.y / length };
}
